module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bronze":"Bronze","silver":"Silver","gold":"Gold","platinum":"Platinum","diamond":"Diamond","media":"Media"},"fr":{"bronze":"Bronze","silver":"Argent","gold":"Or","platinum":"Platine","diamond":"Diamant","media":"Média"},"de":{"bronze":"Bronze","silver":"Geld","gold":"Oder","platinum":"Platine","diamond":"Diamant","media":"Durchschnitt"}}')
  delete Component.options._Ctor
}
